"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLevelPipStyles = void 0;
const styles = {
    root: {
        maxHeight: 25,
        minHeight: 5,
        width: 5,
        backgroundColor: "black",
        transition: "height",
        transitionTimingFunction: "cubic-bezier(.4,0,.2,1)",
        transitionDuration: "80ms",
        borderRadius: "1000px",
    },
};
function getLevelPipStyles(level) {
    return {
        height: `${level < 0.05 ? 5 : level * 40}px`,
    };
}
exports.getLevelPipStyles = getLevelPipStyles;
exports.default = styles;
//# sourceMappingURL=styles.js.map